import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import tagsLabel from '../common/helpers/tagsLabel';
export default function addTagComposer() {
  extend('flarum/forum/components/DiscussionComposer', 'oninit', function () {
    this.composer.fields.tags ||= [];
    this.constructor.prototype.chooseTags = function () {
      app.modal.show(() => import(/* webpackChunkName: 'forum/components/TagDiscussionModal', webpackMode: 'lazy-once' */ './components/TagDiscussionModal'), {
        selectedTags: this.composer.fields.tags.slice(),
        onsubmit: tags => {
          this.composer.fields.tags = tags;
          this.$('textarea').focus();
        }
      });
    };
  });
  extend('flarum/forum/components/DiscussionComposer', 'headerItems', function (items) {
    const tags = this.composer.fields.tags || [];
    items.add('tags', m(Button, {
      className: "DiscussionComposer-changeTags Button Button--link",
      onclick: () => this.chooseTags()
    }, tags.length ? tagsLabel(tags) : 'Choose labels'), 10);
  });
  override('flarum/forum/components/DiscussionComposer', 'onsubmit', function (original) {
    const tags = this.composer.fields.tags || [];
    if (!app.forum.attribute('canBypassTagCounts') && (tags.length < app.forum.attribute('minLabels') || tags.length > app.forum.attribute('maxLabels'))) {
      this.chooseTags();
      return;
    }
    return original();
  });
  extend('flarum/forum/components/DiscussionComposer', 'data', function (data) {
    data.relationships ||= {};
    data.relationships.tags = this.composer.fields.tags || [];
  });
}